export default class UserManager {
  static instance = null;

  bibNumber;
  level;

  static getInstance() {
    if (UserManager.instance === null) {
      UserManager.instance = new UserManager();
    }

    return this.instance;
  }

  isAuthenticated() {
    return !!(this.bibNumber && this.level);
  }
}
